import React, { useState } from 'react';

const Sidebar = ({ setCurrentPage, currentPage }) => {
  const [isCollapsed, setIsCollapsed] = useState(false);

  const toggleSidebar = () => {
    setIsCollapsed(!isCollapsed);
  };

  return (
    <div className={`sidebar ${isCollapsed ? 'collapsed' : ''}`}>
      <button className="sidebar-toggle" onClick={toggleSidebar}>
        <i className="bi bi-list"></i>
      </button>
      <button
        onClick={() => setCurrentPage('Dashboard')}
        className={`sidebar-button ${currentPage === 'Dashboard' ? 'active' : ''}`}
        title="Dashboard"
      >
        <i className="bi bi-speedometer2"></i>
        {!isCollapsed && <span>Dashboard</span>}
      </button>
      <button
        onClick={() => setCurrentPage('GSTInvoice')}
        className={`sidebar-button ${currentPage === 'GSTInvoice' ? 'active' : ''}`}
        title="Create PR"
      >
        <i className="bi bi-plus-circle"></i>
        {!isCollapsed && <span>Create PR</span>}
      </button>
      <button
        onClick={() => setCurrentPage('PRList')}
        className={`sidebar-button ${currentPage === 'PRList' ? 'active' : ''}`}
        title="PR List"
      >
        <i className="bi bi-table"></i>
        {!isCollapsed && <span>PR List</span>}
      </button>
      <button
        onClick={() => setCurrentPage('VendorList')}
        className={`sidebar-button ${currentPage === 'VendorList' ? 'active' : ''}`}
        title="Vendor List"
      >
        <i className="bi bi-clipboard-check"></i>
        {!isCollapsed && <span>Vendor List</span>}
      </button>
      <button
        onClick={() => setCurrentPage('Report')}
        className={`sidebar-button ${currentPage === 'Report' ? 'active' : ''}`}
        title="Report"
      >
        <i className="bi bi-bar-chart-line"></i>
        {!isCollapsed && <span>Report</span>}
      </button>
    </div>
  );
};

export default Sidebar;
